import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from '@mui/material';

interface PageData {
  path: string;
  views: number;
  unique_sessions: number;
}

interface TopPagesTableProps {
  data: PageData[];
  loading: boolean;
}

const TopPagesTable: React.FC<TopPagesTableProps> = ({ data, loading }) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Top Pages
        </Typography>

        {loading ? (
          <Box>
            {[...Array(5)].map((_, i) => (
              <Skeleton key={i} height={40} sx={{ mb: 1 }} />
            ))}
          </Box>
        ) : data.length === 0 ? (
          <Typography color="text.secondary">No page data available</Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Page</TableCell>
                  <TableCell align="right">Views</TableCell>
                  <TableCell align="right">Unique Visitors</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.slice(0, 10).map((page, index) => (
                  <TableRow key={index} hover>
                    <TableCell
                      sx={{
                        fontFamily: 'monospace',
                        fontSize: '0.85rem',
                        maxWidth: 300,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {page.path}
                    </TableCell>
                    <TableCell align="right">{page.views.toLocaleString()}</TableCell>
                    <TableCell align="right">{page.unique_sessions.toLocaleString()}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default TopPagesTable;
